import { useState } from "react";
import { Form, Modal, Row, Col, Radio } from "antd";
import lang from "../helper/langHelper";
import { useNavigate } from "react-router";

const DeleteModal = ({ show, hide, onOk, title, subtitle, reasons, icon }) => {
  const navigate = useNavigate(); 
  return (
    <Modal
      width={550}
      open={show}
      onOk={onOk}
      maskClosable={false}
      okText={"Logout"}
      cancelText={"Cancel"}
      onCancel={hide}
      centered
      className=""
    >
      <Form layout="vertical" className="p-2">
        <div className="logout-modal-main">
        <div className="logout-modal-icon">
          <img src={icon} />
        </div>
        <h4 className="modal_title_cls mb-2">{title}</h4>
        <p className="modal_sub_title_cls mb-2 ">{subtitle}</p>
       </div>
      </Form>
    </Modal>
  );
};

export default DeleteModal;
